module.exports = __webpack_public_path__ + "img/maps1.75d497fb.jpg";